import React, { useEffect, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import BackAnchor from "./BackAnchor";
import ContinueCancelButtons from "./ContinueCancelButtons";
import { clearAllAction } from "../../redux/actions";


const CancelConfirmation = ({ t, i18n }) => {
    const dispatch = useDispatch();

    const datesData = useSelector((state) => state.datesReducer);
    let currentLanguageDates;
    if (datesData) {
        currentLanguageDates = datesData[i18n.language];
    }
    const navigate = useNavigate();
    const handleCancel = () => {
        const url =
            i18n.language === "en"
                ? process.env.REACT_APP_PAGE_NOT_FOUND_URL
                : process.env.REACT_APP_PAGE_NOT_FOUND_URL_FR;

        window.location.replace(url);
        dispatch(clearAllAction())
    }
    return (
        <div>
            <div className="container">
                <main>
                    <article>
                        <div className="row">
                            <div className="col-xs-12 col-sm-8">
                                <h1>{t("cancel_confirmation")}</h1>
                                <p>{t("cancel_confirmation_para")}</p>
                            </div>
                        </div>
                        <ContinueCancelButtons cancel_button={true} continueText={t("shared.yes")} cancelText={t("shared.no")} cancelClick={() => navigate(-1)} continueClick={handleCancel} />
                    </article>
                </main>
            </div>
        </div>
    );
};

export default withTranslation("common")(CancelConfirmation);
